<div
  *ngIf="processDefinition$ | async as processDefinition"
  [class]="processDefinition.processDefinitionKey"
  [style.--highlight-rgb]="processDefinition.backgroundColorRGB"
  class="process-definition-icon">
  <shared-ui-flow-icon [icon]="processDefinition.icon" size="normal"></shared-ui-flow-icon>
</div>
